import axios from 'axios';
import {
  LOGIN_ENDPOINT,
  REGISTER_ENDPOINT,
  ADS_ENDPOINT,
  SPONSORS_ENDPOINT,
  HL_PRODUCTS_ENDPOINT,
  PRODUCTS_ENDPOINT,
  FILTERS_ENDPOINT,
  BRANDS_ENDPOINT,
  AVAILABLE_DATES_ENDPOINT,
  MAKE_ORDER_ENDPOINT,
  ORDERS_ENDPOINT,
  ORDER_PDF_ENDPOINT,
  WPP_SETTINGS_ENDPOINT,
  APPROVE_ENDPOINT
} from '../utils/constants';
import { showToast } from '../utils/utils';


// Generic GET request
export const getRequest = async (endpoint, headers = {}, responseType = 'json') => {
  try {
    const response = await axios.get(`${endpoint}`, { headers, responseType });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Generic POST request
export const postRequest = async (endpoint, data, headers = {}) => {
  try {
    const response = await axios.post(`${endpoint}`, data, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Login requests
export const loginUser = async (username, password) => {
  return await postRequest(LOGIN_ENDPOINT, { username, password });
};

export const registerUser = async (data) => {
  return await postRequest(REGISTER_ENDPOINT, data);
};

// Landing requests
export const getAdImages = async () => {
  try {
    const response = await getRequest(ADS_ENDPOINT);
    return response?.image_paths || [];
  } catch (error) {
    showToast('error', 'Error de red');
    return [];
  }
};

export const getSponsorIcons = async () => {
  try {
    const response = await getRequest(SPONSORS_ENDPOINT);
    return response?.logo_paths || [];
  } catch (error) {
    return [];
  }
};

export const getHighlightedProducts = async () => {
  try {
    const response = await getRequest(HL_PRODUCTS_ENDPOINT);
    return response || [];
  } catch (error) {
    return [];
  }
};

// Product requests
export const getProducts = async () => {
  try {
    const response = await getRequest(PRODUCTS_ENDPOINT);
    return response?.catalog || [];
  } catch (error) {
    showToast('error', 'Error al obtener los productos');
    return [];
  }
};

export const getFilters = async () => {
  try {
    const response = await getRequest(FILTERS_ENDPOINT);
    return response?.categories || [];
  } catch (error) {
    return [];
  }
};

export const getBrands = async () => {
  try {
    const response = await getRequest(BRANDS_ENDPOINT);
    return response?.brands || [];
  } catch (error) {
    return [];
  }
};

// Order requests
export const getAvailableDates = async () => {
  try {
    const response = await getRequest(AVAILABLE_DATES_ENDPOINT);
    return response || {};
  } catch (error) {
    throw error;
  }
};

export const makeOrder = async (data, headers) => {
  return await postRequest(MAKE_ORDER_ENDPOINT, data, headers);
};

export const getOrders = async (headers) => {
  try {
    const response = await getRequest(ORDERS_ENDPOINT, headers);
    return response || [];
  } catch (error) {
    return [];
  }
}

export const getOrderPdf = async (headers, id) => {
  try {
    const response = await getRequest(
      ORDER_PDF_ENDPOINT + id,
      headers,
      'blob'
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export const isApprove = async (headers, id) => {
  try {
    let url = APPROVE_ENDPOINT + id;
    const response = await getRequest(url, headers);
    return response || false;
  } catch (error) {
    throw error;
  }
}

// Social requests
export const getWhatsAppDetails = async () => {
  try {
    const response = await getRequest(WPP_SETTINGS_ENDPOINT);
    return response;
  } catch (error) {
    throw error;
  }
};
